<ng-template [cdkPortalOutlet]="presenterOutlet" (attached)="attached($event)" />